import { Grid, Box } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'

import useAlertPurchase from '@hook/alerts/use-alert-purchase'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantityAlertPurchase from '@component/Layout/TableGrid/GridQuantityAlert/GridQuantityAlertPurchase'
import LayoutTools from '@component/Layout/Tools'
import BarToggleProcess from '@component/Modules/Alert/BarToggleProcess'

import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const PurchaseProcessView: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    actions,
    dataFour,
    getData,
    data,
    visibleData,
    dataTwo,
    dataTree,
    typeGrid,
    filename,
    tableInteraction,
    params,
    currentyDate,
    pagination,
    handlePageChange,
    filters,
    setFilters,
    filtersList,
    getCenters,
    clearAllFilters,
    handleUpdateParams
  } = useAlertPurchase()

  useEffect(() => {
    getData()
    getCenters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 270px)'
          : 'calc(100vh - 239px)'
        : hasSessions
        ? 'calc(100vh - 411px)'
        : 'calc(100vh - 380px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          // handleLocalParams()
          getFilters({
            companies: true,
            centers: true,
            categoryManagers: true,
            productManagers: true,
            worlds: true,
            compactCategories: true,
            abcCurves: true,
            purchaseOrderType: true,
            providersForPurchase: true,
            centerTypes: true,
            purchases: true,
            users: true,
            typeOfSupply: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Layout title="Alertas de Compra">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            defaultDate={currentyDate}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box h={height} maxW="100%" overflow="auto">
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
          />

          {/* <SupplyFilter /> */}
          {/* {paramsEdit.fornecedor.length > 0 ? (
            <Text ml={6} p={1}>
              Fornecedores Selecionados: {paramsEdit.fornecedor.length}
            </Text>
          ) : (
            <Text fontSize={12} ml={6} p={1} color={'red'}>
              Selecione um fornecedor
            </Text>
          )} */}

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : (
            <>
              <BarToggleProcess />

              {data.length === 0 ? (
                <LayoutEmpty
                  title="Nada encontrado!"
                  message="Filtre sua busca ao lado para obter informações"
                />
              ) : (
                <>
                  <GridQuantityAlertPurchase
                    data={visibleData}
                    disabled={visibleData.length === 0}
                  />

                  {typeGrid === 1 ? (
                    <TableGrid
                      id="alert-purchase-proces"
                      headers={headers}
                      data={data}
                      height={tableHeight}
                      itsSortable={true}
                      entity="alert-purchase-proces"
                      actions={tableInteraction}
                      onSelect={handlePageChange}
                      pagination={pagination}
                    />
                  ) : (
                    []
                  )}
                  {typeGrid === 2 ? (
                    <TableGrid
                      id="alert-purchase-proces"
                      headers={headers}
                      data={dataTwo}
                      height={tableHeight}
                      itsSortable={true}
                      entity="alert-followUp"
                      actions={tableInteraction}
                      onSelect={handlePageChange}
                      pagination={pagination}
                    />
                  ) : (
                    []
                  )}
                  {typeGrid === 3 ? (
                    <TableGrid
                      id="alert-purchase-proces"
                      headers={headers}
                      data={dataTree}
                      height={tableHeight}
                      itsSortable={true}
                      entity="alert-followUp"
                      actions={tableInteraction}
                      onSelect={handlePageChange}
                      pagination={pagination}
                    />
                  ) : (
                    []
                  )}
                  {typeGrid === 4 ? (
                    <TableGrid
                      id="alert-purchase-proces"
                      headers={headers}
                      data={dataFour}
                      height={tableHeight}
                      itsSortable={true}
                      entity="alert-followUp"
                      actions={tableInteraction}
                      onSelect={handlePageChange}
                      pagination={pagination}
                    />
                  ) : (
                    []
                  )}
                </>
              )}
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default PurchaseProcessView
